export default __webpack_public_path__ + "static/media/turismo.d9a65467.jpg";